<template>
  <div v-if="comType == 'UI'">
    <div
      class="menu-view"
      :style="{
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
        'background-color': backgroundColor,
      }"
    >
      <div class="menu-content">
        <div
          :style="{
            'border-radius': `${radius}px`,
            'background-color': backgroundColor,
          }"
          v-if="dineInIsShow"
        >
          <h1>
            <span style="--buttonColor: #ee5654; --labelColor: #f16b6b">{{
              dineInTitle
            }}</span>
          </h1>
          <p>{{ dineInSubTitle }}</p>
          <img
            :src="
              dineInCustomImg && dineInCustomImgUrl
                ? dineInCustomImgUrl
                : `./static/img/decoration/orderType-ts.png`
            "
            draggable="false"
            v-show="dineInIsShowImg"
          />
        </div>
        <div
          :style="{
            'border-radius': `${radius}px`,
            'background-color': backgroundColor,
          }"
          v-if="takeOutIsShow"
        >
          <h1>
            <span style="--buttonColor: #ee5654; --labelColor: #f16b6b">{{
              takeOutTitle
            }}</span>
          </h1>
          <p>{{ takeOutSubTitle }}</p>
          <img
            :src="
              takeOutCustomImg && takeOutCustomImgUrl
                ? takeOutCustomImgUrl
                : `./static/img/decoration/orderType-wm.png`
            "
            draggable="false"
            v-show="takeOutIsShowImg"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="类型"> 堂食 </el-form-item>
        <el-form-item label="是否展示">
          <el-switch v-model="dineInIsShowValue" active-text="展示"> </el-switch>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            type="text"
            size="small"
            v-model="dineInTitleValue"
            maxlength="8"
            show-word-limit
            clearable
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="text"
            size="small"
            v-model="dineInSubTitleValue"
            maxlength="16"
            show-word-limit
            clearable
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="设置">
          <el-switch v-model="dineInIsShowImgValue" active-text="展示图片"> </el-switch>
          <div v-show="dineInIsShowImgValue">
            <el-switch
              v-show="dineInIsShowImgValue"
              v-model="dineInCustomImgValue"
              active-text="自定义图片"
            >
            </el-switch>
          </div>
          <div v-show="dineInCustomImgValue && dineInIsShowImgValue">
            <customUpload :imageUrl.sync="dineInCustomImgUrlValue"></customUpload>
            <div class="tip">建议图片尺寸:宽110*高80px</div>
          </div>
        </el-form-item>
      </div>
      <el-divider></el-divider>
      <div>
        <el-form-item label="类型"> 外卖 </el-form-item>
        <el-form-item label="是否展示"
          ><el-switch v-model="takeOutIsShowValue" active-text="展示"> </el-switch>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            type="text"
            size="small"
            v-model="takeOutTitleValue"
            maxlength="8"
            show-word-limit
            clearable
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="text"
            size="small"
            v-model="takeOutSubTitleValue"
            maxlength="16"
            show-word-limit
            clearable
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="设置">
          <el-switch v-model="takeOutIsShowImgValue" active-text="展示图片"> </el-switch>
          <div v-show="takeOutIsShowImgValue">
            <el-switch v-model="takeOutCustomImgValue" active-text="自定义图片">
            </el-switch>
          </div>
          <div v-show="takeOutCustomImgValue && takeOutIsShowImgValue">
            <customUpload :imageUrl.sync="takeOutCustomImgUrlValue"></customUpload>
            <div class="tip">建议图片尺寸:宽110*高80px</div>
          </div>
        </el-form-item>
      </div>
      <el-divider></el-divider>
      <div>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <div>
          <el-form-item label="圆角">
            <div class="slider-block">
              <el-slider v-model="radiusValue" show-input :min="0" :max="50"> </el-slider>
              <div class="set-radius">
                <el-popover placement="top" width="160" trigger="hover">
                  <radiusBox :radius="radiusValue"></radiusBox>
                  <el-button slot="reference">可见性</el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上间距">
            <div class="slider-block">
              <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下间距">
            <div class="slider-block">
              <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左间距">
            <div class="slider-block">
              <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右间距">
            <div class="slider-block">
              <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="上内间距">
            <div class="slider-block">
              <el-slider v-model="paddingTopValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下内间距">
            <div class="slider-block">
              <el-slider v-model="paddingBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左内间距">
            <div class="slider-block">
              <el-slider v-model="paddingLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右内间距">
            <div class="slider-block">
              <el-slider v-model="paddingRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import customUpload from "@/components/appltDecoration/customUpload";
import radiusBox from "@/components/appltDecoration/radiusBox";
import { comMixins } from "@/mixins/comMixins";

export default {
  mixins: [comMixins],
  name: "comOrderMethod",
  components: { radiusBox, customUpload },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    dineInIsShow: {
      type: Boolean,
      default: true,
    },
    dineInTitle: {
      type: String,
      default: "到店自取",
    },
    dineInSubTitle: {
      type: String,
      default: "下单免排队",
    },
    dineInIsShowImg: {
      type: Boolean,
      default: true,
    },
    dineInCustomImg: {
      type: Boolean,
      default: false,
    },
    dineInCustomImgUrl: {
      type: String,
      default: "",
    },
    takeOutIsShow: {
      type: Boolean,
      default: true,
    },
    takeOutTitle: {
      type: String,
      default: "外卖点单",
    },
    takeOutSubTitle: {
      type: String,
      default: "一步到位，真快乐",
    },
    takeOutIsShowImg: {
      type: Boolean,
      default: true,
    },
    takeOutCustomImg: {
      type: Boolean,
      default: false,
    },
    takeOutCustomImgUrl: {
      type: String,
      default: "",
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
    paddingTop: {
      type: Number,
      default: 10,
    },
    paddingRight: {
      type: Number,
      default: 10,
    },
    paddingBottom: {
      type: Number,
      default: 10,
    },
    paddingLeft: {
      type: Number,
      default: 10,
    },
    backgroundColor: {
      type: String,
      default: "rgba(255,255,255,1)",
    },
    radius: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    dineInIsShowValue: {
      get() {
        return this.dineInIsShow;
      },
      set(val) {
        this.$emit(`update:dineInIsShow`, val);
      },
    },
    dineInTitleValue: {
      get() {
        return this.dineInTitle;
      },
      set(val) {
        this.$emit(`update:dineInTitle`, val);
      },
    },
    dineInSubTitleValue: {
      get() {
        return this.dineInSubTitle;
      },
      set(val) {
        this.$emit(`update:dineInSubTitle`, val);
      },
    },
    dineInIsShowImgValue: {
      get() {
        return this.dineInIsShowImg;
      },
      set(val) {
        this.$emit(`update:dineInIsShowImg`, val);
      },
    },
    dineInCustomImgValue: {
      get() {
        return this.dineInCustomImg;
      },
      set(val) {
        this.$emit(`update:dineInCustomImg`, val);
      },
    },
    dineInCustomImgUrlValue: {
      get() {
        return this.dineInCustomImgUrl;
      },
      set(val) {
        this.$emit(`update:dineInCustomImgUrl`, val);
      },
    },
    takeOutIsShowValue: {
      get() {
        return this.takeOutIsShow;
      },
      set(val) {
        this.$emit(`update:takeOutIsShow`, val);
      },
    },
    takeOutTitleValue: {
      get() {
        return this.takeOutTitle;
      },
      set(val) {
        this.$emit(`update:takeOutTitle`, val);
      },
    },
    takeOutSubTitleValue: {
      get() {
        return this.takeOutSubTitle;
      },
      set(val) {
        this.$emit(`update:takeOutSubTitle`, val);
      },
    },
    takeOutIsShowImgValue: {
      get() {
        return this.takeOutIsShowImg;
      },
      set(val) {
        this.$emit(`update:takeOutIsShowImg`, val);
      },
    },
    takeOutCustomImgValue: {
      get() {
        return this.takeOutCustomImg;
      },
      set(val) {
        this.$emit(`update:takeOutCustomImg`, val);
      },
    },
    takeOutCustomImgUrlValue: {
      get() {
        return this.takeOutCustomImgUrl;
      },
      set(val) {
        this.$emit(`update:takeOutCustomImgUrl`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
    radiusValue: {
      get() {
        return this.radius;
      },
      set(val) {
        this.$emit(`update:radius`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
    paddingTopValue: {
      get() {
        return this.paddingTop;
      },
      set(val) {
        this.$emit(`update:paddingTop`, val);
      },
    },
    paddingRightValue: {
      get() {
        return this.paddingRight;
      },
      set(val) {
        this.$emit(`update:paddingRight`, val);
      },
    },
    paddingBottomValue: {
      get() {
        return this.paddingBottom;
      },
      set(val) {
        this.$emit(`update:paddingBottom`, val);
      },
    },
    paddingLeftValue: {
      get() {
        return this.paddingLeft;
      },
      set(val) {
        this.$emit(`update:paddingLeft`, val);
      },
    },
  },
};
</script>

<style scoped lang="less">
.menu-view {
  background: none !important;
}

.menu-content {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  overflow: hidden;
}

.menu-content > div {
  width: 48%;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  overflow: hidden;
  margin-right: 5px;
  margin-left: 5px;
  padding-bottom: 15px;
}

.menu-content > div img {
  width: 114px;
  height: 84px;
  float: right;
  margin-top: 5px;
}

.menu-content > div h1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  font-weight: 800;
  color: #0a0a0a;
  margin-bottom: 2px;
}

.menu-content > div h1 span {
  position: relative;
  z-index: 9;
}

.menu-content > div h1 span:after {
  content: "";
  position: absolute;
  background-color: var(--buttonColor);
  width: 100%;
  height: 5px;
  left: 0;
  bottom: 2px;
  opacity: 0.4;
  z-index: 5;
}

.menu-content > div p {
  font-size: 11px;
  font-weight: 400;
  color: #707070;
  z-index: 2;
  position: relative;
}

.menu-content-more {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  overflow: hidden;
  height: 220px;
}

.menu-content-more > div {
  flex: 1;
  position: relative;
  float: left;
}

.menu-content-more > div img {
  width: 75px;
  height: 58px;
  position: absolute;
  right: 5px;
  bottom: 5px;
}

.menu-content-more > div p {
  width: 85px;
}

.menu-content-more > div:first-child {
  min-height: 100%;
}

.menu-content-more > div:first-child img {
  width: 114px;
  height: 84px;
}

.menu-content-more > div:nth-child(2) {
  margin-bottom: 10px;
}
</style>
